import { render, staticRenderFns } from "./BaseRate.vue?vue&type=template&id=f15c39b6&"
import script from "./BaseRate.vue?vue&type=script&lang=js&"
export * from "./BaseRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports